import { render } from "./ChevronDoubleDown.vue?vue&type=template&id=5bcbb0d6"
import script from "./ChevronDoubleDown.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleDown.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__